import { ENABLE_CREDIT_CARD_INFO_MODAL } from './types';
import { disableBodyScroll } from '../../util';

const enableCreditCardInfoModal = () => {
  disableBodyScroll();
  return { type: ENABLE_CREDIT_CARD_INFO_MODAL };
};

export default enableCreditCardInfoModal;



// WEBPACK FOOTER //
// ./src/actions/modals/enableCreditCardInfoModal.js